//Get resolved axios into Repository
import Repository from '@/app/repositories/repository'

function BaseClass(name){
    this.resource = name;
}

BaseClass.prototype.getSchema = function() {
    return Repository.get(`${this.resource}/getSchema`);
};

BaseClass.prototype.getFiltered = function() {
    //Only get id and name
    return Repository.get(`${this.resource}/getFiltered`);
};

BaseClass.prototype.get = function() {
    return Repository.get(`${this.resource}/getAll`);
};

BaseClass.prototype.getById = function(id) {
    return Repository.get(`${this.resource}/getById?id=`+id);
};

BaseClass.prototype.create = function(data) {
    return Repository.post(`${this.resource}/add/`, data)
};

BaseClass.prototype.update = function(data) {
    return Repository.post(`${this.resource}/update`, data);
};

BaseClass.prototype.delete = function(data) {
    return Repository.post(`${this.resource}/delete`, data);
};

//Test
function DerivedClass(resource){
    BaseClass.call(this, resource);
}

DerivedClass.prototype = Object.create(BaseClass.prototype);

const repositories = {
    // assets: new DerivedClass('asset'),
    // components: new DerivedClass('component'),
    // layouts: new DerivedClass('layout'),
    // pages: new DerivedClass('page'),
    // pagesMeta: new DerivedClass('pageMeta'),
    // templates: new DerivedClass('template'),
    // sass: new DerivedClass('sass'),
    // settings: new DerivedClass('setting'),

    uom: new DerivedClass('uom'),

    // projects: new DerivedClass('company'),
    user: new DerivedClass('userInfo'), //TODO- Change API name
    // roles: new DerivedClass('role'),//TODO- Change API name

    order: new DerivedClass('order'),
    product: new DerivedClass('product'),
    category: new DerivedClass('category'),
    // storeProviders: new DerivedClass('supplier'),
    shoppingCart: new DerivedClass('shoppingCart'),

    account: new DerivedClass('account')
};

export const RepositoryFactory = {
    get: name => repositories[name]
};
